import ToggleButton from "@client/controls/Button/ToggleButton/component";
import withIsVisibleHOC from "@client/hocs/withIsVisible";
import HeaderElement from "@client/widgets/Header/Element/container";
import * as React from "react";

export interface HeaderMainMenuToggleMapProps {
  className?: string;
  isOpen: boolean;
}

export interface HeaderMainMenuToggleActionProps {
  onClick: () => void;
}
export type HeaderMainMenuToggleProps = HeaderMainMenuToggleActionProps & HeaderMainMenuToggleMapProps;
const HeaderMainMenuToggle = (props: HeaderMainMenuToggleProps) => (
  <HeaderElement className={props.className}>
    <ToggleButton isToggled={props.isOpen} onClick={props.onClick} />
  </HeaderElement>
);

export default withIsVisibleHOC(HeaderMainMenuToggle);
